import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';

import { environment } from "../../../environments/environment";

import { CmsService } from 'src/app/Services/cms.service';
import { ExternalService } from 'src/app/Services/external.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    standalone: false
})
export class FooterComponent implements OnInit{
  year: number = new Date().getFullYear();
  phoneNumberGeneral: string;
  phoneLink: SafeUrl;
  systemNameShort: string;
  devByShort: string;

  language: string = '';
  defaultLanguage: string = environment.defaultLanguage;

  footer_content: string = 'linhas-footer'
  footerInfo: any = {};

  feedVersion: string | undefined = undefined;

  constructor(
    private cmsService: CmsService,
    private externalService: ExternalService,
    private router: Router,
    private sanitizer: DomSanitizer
  ) {
    this.systemNameShort = environment.systemNameShort;
    this.devByShort = environment.devByShort;
    this.phoneNumberGeneral = environment.phoneNumberGeneral;
    this.phoneLink = this.sanitizer.bypassSecurityTrustUrl(`tel:${environment.phoneNumberGeneralClean}`);

    let lang = localStorage.getItem('language') ?? this.defaultLanguage;
    this.language = lang.split('-')[0];
  }

  ngOnInit() {
    this.getFooter();
    this.getFeedInfo();
  }

  getFooter(){

    this.cmsService.getContentList(this.footer_content, this.language).subscribe(
      {
        next: data => {
          this.footerInfo = data['body']['data']
        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    );
  }

  getFeedInfo(){

    this.externalService.getFeedInfo().subscribe(
      {
        next: data => {
          this.feedVersion = data
            .map(item => `Lote ${(item as any).agency_id} - ${(item as any).feed_version}`)
            .join(", ");
        },
        error: er => {
        }
      }
    )
  }
}
